import { FC, useMemo } from 'react'

import useTable from '@hook/shared/use-table'

import { toLocaleString2 } from '@helper/grid/strings'
import { parseCurrency } from '@helper/parseCurrency'

const TableGridFooterFollowUp: FC<{ filterDate: string }> = ({
  filterDate
}) => {
  const { data: rows } = useTable()

  const firstObject = useMemo(() => {
    let aFornecer = 0
    let aFornecerRs = 0
    let totalPedido = 0
    const objFilter = rows.data.filter(
      (x: any) => x['general-pedido'] === filterDate
    )
    for (const obj of objFilter) {
      let formattedValue = String(obj['general-a-fornecer']).replace(',', '')
      formattedValue = String(formattedValue).replace('.', '')

      aFornecer += Number(formattedValue)
      aFornecerRs += obj['general-a-fornecer-rs']
      totalPedido += obj['general-total-pedido']
    }

    const totalObj = {
      afornecer: aFornecer,
      afornecerRs: aFornecerRs,
      totalPedido: totalPedido
    }
    return totalObj
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <tr>
        <td colSpan={5} align="right">
          {' '}
          <b>Total</b>
        </td>
        <td></td>
        <td> {toLocaleString2(firstObject.afornecer)} </td>
        <td>
          {' '}
          {parseCurrency({
            value: firstObject.afornecerRs,
            country: 'pt-br'
          })}{' '}
        </td>

        <td colSpan={2}></td>
      </tr>{' '}
    </>
  )
}
export default TableGridFooterFollowUp
